import Image from "next/legacy/image";

import HomeHeader from "@/components/home/HomeHeader";
import SeoLinks from "@/components/home/SeoLinks";
import HomeFooter from "@/components/home/HomeFooter";

import CpHomeHeader from "@/components/communityPortal/home/CpHomeHeader";
import CpHomeFooter from "@/components/communityPortal/home/CpHomeFooter";
import { OurStory } from "../home/HowItWorks";

import { imageLoader } from "@/utils/image";

const AboutUs = ({ communityPortal = false }) => {
    return (
        <div className="relative h-screen">
            {communityPortal ? <CpHomeHeader fixed /> : <HomeHeader fixed />}

            <div className="relative">
                <div className="sm:hidden relative w-full h-72">
                    <Image
                        loader={imageLoader}
                        src="https://cdn.purpledoorfinders.com/purpledoorfinders/purpledoorfinders-about-us"
                        alt="about us"
                        layout="fill"
                        objectFit="cover"
                        objectPosition="left top"
                        priority
                        unoptimized={false}
                        className=""
                    />
                </div>

                <div className="pt-12 container mx-auto px-8 sm:px-16">
                    <div className="w-full sm:w-1/2 pt-8 sm:pt-32 pr-8 min-h-[600px]">
                        <h2 className="text-gray-sec text-2xl font-bold tracking-normal font-headline uppercase">
                            About Us
                        </h2>
                        <h1 className="mt-2 text-primary-500 text-4xl font-bold tracking-normal font-headline">
                            We Put Seniors And Their Loved Ones First
                        </h1>

                        <p className="mt-12 pb-8 text-lg">
                            Purple Door Finders is the new way to find senior living and
                            care options. Our platform is the most comprehensive, accessible
                            online resource for senior and assisted living search. We
                            provide seniors and their families with the tools and support to
                            find senior living and assisted living—in the easiest way
                            possible.
                        </p>
                    </div>
                </div>

                <div className="hidden sm:block absolute top-0 left-1/2 right-0 bottom-0">
                    <Image
                        loader={imageLoader}
                        src="https://cdn.purpledoorfinders.com/purpledoorfinders/purpledoorfinders-about-us"
                        alt="about us"
                        layout="fill"
                        objectFit="cover"
                        objectPosition="left top"
                        priority
                        unoptimized={false}
                        className=""
                    />
                </div>
            </div>

            <div className="w-full bg-primary-med">
                <div className="container mx-auto px-8 sm:px-16">
                    <div className="py-16 text-white">
                        <h2 className="text-center text-white text-4xl font-headline font-bold uppercase">
                            Our Promise
                        </h2>

                        <div className="mt-16 grid grid-cols-1 gap-y-12">
                            <Promise title="Comprehensive + Accessible">
                                Purple Door Finders allows you to search one of the most
                                comprehensive online databases of senior and assisted living
                                options. Search for a wide variety of senior living
                                options­­–independent care homes to large full-amenity
                                communities from senior apartments to managed memory care
                                and respite–with thorough listings and pricing from verified
                                communities. Best of all, there is no cost to seniors and
                                their families.
                            </Promise>

                            <Promise title="Support + Tools">
                                Every senior and family has different needs and preferences.
                                Learn about your options and types of senior living using
                                our tools and resources. Our Tools & Resources not only help
                                you determine the best senior living for your needs, but
                                they also help you manage the process with checklists,
                                assessments, and more.
                            </Promise>

                            <Promise title="Empowering + Direct">
                                If you choose, Purple Door team members are available to
                                assist you with your search. We do our best to show you as
                                many options as are available or that we can find in your
                                search area. Seniors and their advocates can search at no
                                charge, register to use our tools, and directly connect with
                                communities. Communities pay an annual membership fee openly
                                posted on our website.
                            </Promise>

                            {/*<Promise title="Options">
                                Purple Door Finders allows you to search one of the most
                                comprehensive databases of senior and assisted living
                                options near you from independently run care homes to large
                                full-amenity communities from senior apartments to managed
                                memory care to respite.
                            </Promise>

                            <Promise title="Customized">
                                Every senior and family has different needs and preferences.
                                Purple Door Finders allows you to search by those needs and
                                preferences. You will know all your options for senior or
                                assisted living that fit you best.
                            </Promise>

                            <Promise title="Support">
                                Purple Door Finders’ tools and resources allow you manage
                                the process of finding senior and assisted living in a way
                                you never have been able to before. You can manage your
                                search preferences, track the communities you are interested
                                in, compare them, manage the process of touring, and
                                communicate directly with the communities all from your
                                senior portal.
                            </Promise>

                            <Promise title="Empowering">
                                At Purple Door Finders you will not find agents,
                                specialists, or advisors selling you communities in our
                                network. We bring you all of your options, unbiased. You are
                                able to do all of this anonymously, sharing your information
                                only with communities you have approved and requested to
                                speak with.
                            </Promise>

                            <Promise title="Accessible">
                                It is completely free to seniors and their families.
                                Communities pay a membership fee that allows you to
                                communicate directly with them cutting out third-party,
                                biased sales people and allows them to share more
                                information about their communities with you such as the
                                current availability of units and rates.
                            </Promise>*/}
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mx-auto px-8 sm:px-16 flex justify-center">
                <div className="py-16 max-w-3xl">
                    <h2 className="text-center text-primary-500 text-4xl font-headline font-bold uppercase">
                        Our Beliefs.
                    </h2>

                    <div className="mt-8 flex flex-col space-y-8">
                        <Belief title="We believe that...">
                            seniors and their families should have more tools and resources
                            to help them find senior living—independently.
                        </Belief>

                        <Belief title="We believe that...">
                            transparency of information should include fees, availability,
                            and the ability to shop and compare as many options as possible.
                        </Belief>

                        <Belief title="We believe in...">
                            the ethical use of technology and data to improve the process of
                            finding senior and assisted living.
                        </Belief>

                        <Belief title="We believe that...">
                            internet shoppers are savvy and want to find the information
                            they seek online immediately.
                        </Belief>
                    </div>
                </div>
            </div>

            <div className="w-full bg-gray-100/50">
                <div className="container mx-auto px-8 sm:px-16 pt-8">
                    <OurStory />
                </div>
            </div>

            {communityPortal ? null : <SeoLinks />}
            {communityPortal ? <CpHomeFooter /> : <HomeFooter />}
        </div>
    );
};

const Promise = ({ title, children }) => {
    return (
        <div>
            <h3 className="text-center text-white text-2xl font-headline font-bold uppercase">
                {title}
            </h3>
            <p className="mt-4 text-center text-lg">{children}</p>
        </div>
    );
};

const Belief = ({ title, children }) => {
    return (
        <div>
            <h3 className="text-center text-gray-med text-3xl font-headline font-bold">
                {title}
            </h3>
            <p className="mt-4 text-center text-2xl">{children}</p>
        </div>
    );
};

export default AboutUs;
